import { FunctionComponent, useEffect, useRef, useState } from "react";
import "./SubjectMobile.scss";
import Table from "../../Components/Table/Table";
import CustomToolbar from "../../Components/Table/components/CustomToolbar";
import ButtonField from "../../Components/Button/ButtonField";
import { Columns } from "../../Components/Table/ITable";
import {
  GridRenderCellParams,
  GridValueFormatterParams,
} from "@mui/x-data-grid";
import { ISubjectMobile } from "./ISubjectMobile";
import { useAppDispatch, useAppSelector } from "../../Redux/Store/Hooks";
import Dialog from "../../Components/Dialog/Dialog";
import SubjectMobileForm from "./SubjectMobileForm";
import ResponseDialog from "../../Components/ResponseDialog/ResponseDialog";
import TableSearch from "../../Components/Table/components/TableSearch";
import { ReactComponent as Delete } from "../../Assets/Images/delete.svg";
import { ReactComponent as Edit } from "../../Assets/Images/edit.svg";
import { IDeleteDialog } from "../../Components/DeleteDialog/IDeleteDialog";
import IconButtonField from "../../Components/Button/IconButtonField";
import { SvgIcon } from "@mui/material";
import DeleteDialog from "../../Components/DeleteDialog/DeleteDialog";
import { ReactComponent as RefreshButton } from "../../Assets/Images/RefreshButton.svg";
import { listSubjectMobile } from "../../Redux/Slices/SubjectMobile/ListSubjectMobileSlice";
import { clearAddSubjectMobileResponse } from "../../Redux/Slices/SubjectMobile/AddSubjectMobileSlice";
import {
  clearDeleteSubjectMobileResponse,
  deleteSubjectMobile,
} from "../../Redux/Slices/SubjectMobile/DeleteSubjectMobileSlice";
import { clearEditSubjectMobileResponse } from "../../Redux/Slices/SubjectMobile/EditSubjectMobileSlice";
import { listSideMenuPermission } from "../../Redux/Slices/SideMenuPermission/ListSideMenuPermissionSlice";
import { listyearGroup } from "../../Redux/Slices/yearGroup/ListyearGroupSlice";

interface SubjectMobileProps { }

const SubjectMobile: FunctionComponent<SubjectMobileProps> = () => {
  const [dialogOpen, setDialogOpen] = useState<boolean>(false);
  const [isEdit, setIsEdit] = useState<boolean>(false);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState<boolean>(false);
  const [deleteDialogData, setDeleteData] = useState<IDeleteDialog>({});
  const [initialValues, setInitialValues] = useState<ISubjectMobile | {}>({
    status: true,
  });
  const dispatch = useAppDispatch();
  const { data: listSubjectMobiles } = useAppSelector(
    (state) => state.ListSubjectMobileSlice
  );
  const { data: addSubjectMobile } = useAppSelector(
    (state) => state.AddSubjectMobileSlice
  );
  const { data: EditSubjectMobile } = useAppSelector(
    (state) => state.EditSubjectMobileSlice
  );
  const { data: deleteSubjectMobiles } = useAppSelector(
    (state) => state.DeleteSubjectMobile
  );

  const permissions = useAppSelector((state) => state.PermissionsToPage);
  const finaldata = { permissions };

  const formRef = useRef<HTMLFormElement>(null);
  const columns: Columns = [
    {
      field: "index",
      renderHeader: () => <b>S.No</b>,
      width: 90,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "name",
      renderHeader: () => <b>Subject</b>,
      flex: 1,
      type: "string",
      headerAlign: "left",
    },
    {
      field: "sequence",
      renderHeader: () => <b>Sequence</b>,
      flex: 1,
      type: "string",
      headerAlign: "left",
    },
    {
      field: "year_levels",
      renderHeader: () => <b>Year Levels</b>,
      flex: 1,
      type: "string",
      headerAlign: "left",
    },
    {
      field: "status",
      renderHeader: () => <b>Status</b>,
      flex: 1,
      type: "string",
      headerAlign: "left",
      cellClassName: (params) =>
        `activename ${params.row.status ? "active" : "inactive"}`,

      valueFormatter: (params) =>
        params.value === true ? "Active" : "Inactive",
    },
    {
      field: "action",
      renderHeader: () => <b>Action</b>,
      flex: 1,
      type: "actions",
      renderCell: (params: GridRenderCellParams<ISubjectMobile>) => {
        return (
          <>
            <IconButtonField
              disabled={finaldata?.permissions?.edit === false}
              onClick={() => {
                setInitialValues({ ...params.row, id: params.id as number });
                setIsEdit(true);
                setDialogOpen(true);
              }}
            >
              <SvgIcon sx={{ fill: "none" }} component={Edit} inheritViewBox />
            </IconButtonField>
            <IconButtonField
              disabled={finaldata?.permissions?.delete === false}
              onClick={() => {
                setDeleteData({ id: params.id, name: params?.row?.name });
                setDeleteDialogOpen(true);
              }}
            >
              <SvgIcon component={Delete} inheritViewBox />
            </IconButtonField>
          </>
        );
      },
    },
  ];

  const SubjectMobile = Array.isArray(listSubjectMobiles?.data)
    ? listSubjectMobiles?.data.map((user, index) => ({
      ...user,
      index: index + 1,
    }))
    : [];

  useEffect(() => {
    dispatch(listSubjectMobile());
    dispatch(listyearGroup());
    // dispatch(listSideMenuPermission());
  }, [addSubjectMobile, EditSubjectMobile, deleteSubjectMobiles, dispatch]);
  useEffect(() => {
    return () => {
      dispatch(clearAddSubjectMobileResponse());
      dispatch(clearEditSubjectMobileResponse());
      dispatch(clearDeleteSubjectMobileResponse());
    };
  }, [dispatch]);
  return (
    <>
      <Table rows={SubjectMobile ?? []} columns={columns} exportFileName="Subjects">
        <CustomToolbar>
          <h6>Subject</h6>
          <TableSearch />
          <ButtonField
            className="tabel_add_new_button"
            onClick={() => {
              setInitialValues({ status: true });
              setIsEdit(false);
              setDialogOpen(true);
            }}
            toolTip="Add new"
            disabled={finaldata?.permissions?.add === false}
          >
            Add new
          </ButtonField>
          <IconButtonField
            className="refresh_btn"
            toolTip="Refresh"
            onClick={() => dispatch(listSubjectMobile())}
          >
            <SvgIcon
              className="refresh_svg_icon"
              component={RefreshButton}
              inheritViewBox
            />
          </IconButtonField>
        </CustomToolbar>
      </Table>

      <Dialog
        open={dialogOpen}
        dialogClassName="dialog_double_input"
        Dialog_Title={`${isEdit ? "Update" : "Add"} Subject`}
        Dialog_Content={
          <SubjectMobileForm
            formRef={formRef}
            initialValues={initialValues}
            setInitialValues={setInitialValues}
          />
        }
        Dialog_Actions={
          <>
            <ButtonField
              className="form_cancel_button"
              onClick={() => {
                setDialogOpen(false);
                setIsEdit(false);
              }}
            >
              Cancel
            </ButtonField>
            <ButtonField
              className="form_save_button"
              onClick={() => formRef.current?.requestSubmit()}
            >
              Save
            </ButtonField>
          </>
        }
      />
      <ResponseDialog
        response={addSubjectMobile}
        parentDialog={setDialogOpen}
      />
      <ResponseDialog
        response={EditSubjectMobile}
        parentDialog={setDialogOpen}
      />
      <DeleteDialog
        deleteableName={deleteDialogData.name ?? ""}
        open={deleteDialogOpen}
        setOpen={setDeleteDialogOpen}
        deleteFunction={() => {
          dispatch(deleteSubjectMobile(deleteDialogData.id));
        }}
        response={deleteSubjectMobiles}
      />
    </>
  );
};

export default SubjectMobile;
